// extracted by mini-css-extract-plugin
export var button = "index-module--button--cN8RT";
export var flat = "index-module--flat--G7oIp";
export var icon = "index-module--icon--bINnR";